import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';
import { ReactNode } from 'react';

type EquipmentDetailsDisclosureProps = {
  expanded: boolean;
  onToggle: () => void;
  children: ReactNode;
  label?: string;
};

export default function EquipmentDetailsDisclosure({
  expanded,
  onToggle,
  children,
  label = 'Details'
}: EquipmentDetailsDisclosureProps) {
  return (
    <div className='flex flex-col gap-1'>
      <button
        type='button'
        onClick={onToggle}
        className='flex w-fit items-center gap-1 text-sm font-medium text-blue-600 hover:text-blue-700'
      >
        {label}
        {expanded ? (
          <ChevronUpIcon className='h-4 w-4' />
        ) : (
          <ChevronDownIcon className='h-4 w-4' />
        )}
      </button>
      <div
        className={clsx(
          'grid transition-[grid-template-rows] duration-300 ease-in-out',
          expanded ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'
        )}
      >
        <div className='overflow-hidden'>{children}</div>
      </div>
    </div>
  );
}
